require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-paolo-fumagalli.json") })
        }
      }, "path---en-interviste-paolo-fumagalli");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-paolo-fumagalli!./.cache/json/en-interviste-paolo-fumagalli.json
// module id = 595
// module chunks = 231608221292675